import React, { ReactNode } from "react";

import { Statesprovider, UserProvider, ProtectedRoute } from ".";
import ThemeProvider from "./ThemeContext";
import { GoogleOAuthProvider } from '@react-oauth/google';
const clientId = process.env.REACT_APP_GOOGLE_AUTH;

const Combined: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <Statesprovider>
      <UserProvider>
        <ThemeProvider>
          <GoogleOAuthProvider clientId={clientId}>
            {/* <ProtectedRoute>{children}</ProtectedRoute> */}
            {children}
          </GoogleOAuthProvider>
        </ThemeProvider>
      </UserProvider>
    </Statesprovider>
  );
};

export default Combined;
